<div id="tsq-error-container">
  <img class="mb-16" src="./assets/img/icons/robot-error.png" alt="" />
  <h3>{{ title || 'COMMON_ERROR_TITLE' | translate | uppercase }}</h3>
  <p>{{ text || 'COMMON_ERROR_TEXT' | translate }}</p>
  <a *ngIf="hasRetry" (click)="retry.emit()">{{ 'RETRY' | translate }}</a>
</div>
